/**
 * Copied from the Gateway SDK because the file download didn't work.
 * Two changes:
 * - Added the 'blob' responseType to the 'request' call
 * https://github.com/swagger-api/swagger-codegen/pull/4060#issuecomment-448230739
 */

// Disabled due to the function parameters from the API are not typed.
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpUrlEncodingCodec,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BASE_PATH, Configuration } from '@rocksoft/gateway-sdk';
import { Observable } from 'rxjs';

@Injectable()
export class ExportService {
  protected readonly httpClient = inject(HttpClient);

  protected basePath = 'https://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor() {
    const basePath = inject(BASE_PATH, { optional: true });
    const configuration = inject(Configuration, { optional: true });

    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param brandId the brand id
   * @param locationId the location id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDeviceDetails(
    brandId?: string,
    locationId?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Blob>;
  public getDeviceDetails(
    brandId?: string,
    locationId?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Blob>>;
  public getDeviceDetails(
    brandId?: string,
    locationId?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Blob>>;
  public getDeviceDetails(
    brandId?: string,
    locationId?: string,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    if (brandId !== undefined && brandId !== null) {
      queryParameters = queryParameters.set('brandId', brandId);
    }

    if (locationId !== undefined && locationId !== null) {
      queryParameters = queryParameters.set('locationId', locationId);
    }

    let headers = this.defaultHeaders;

    // authentication (oauth2) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/octet-stream', 'application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);

    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request('get', `${this.basePath}/export`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers,
      observe,
      reportProgress,
      responseType: 'blob', // Important for file downloads
    });
  }
}

/**
 * Copied from the Gateway SDK. We need it for the ExportService but the SDK doesn't expose it.
 * CustomHttpUrlEncodingCode
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  encodeKey(k: string): string {
    k = super.encodeKey(k);
    return k.replace(/\+/gi, '%2B');
  }
  encodeValue(v: string): string {
    v = super.encodeValue(v);
    return v.replace(/\+/gi, '%2B');
  }
}
